export class AppConstants {
    static LOCALE_LANGUAGE = 'locale_language';
}
